import { useMemo, useState } from "react";
import { Card, SectionHeader, ConfidenceBar, Button } from "../../components/lib";
import { TabBar, ListRow } from "../../components/lib.overlay";
import { AI_APPROVALS, AI_TEAMMATES, AiApproval } from "../../mocks/aiData";

const STATUS_META: Record<AiApproval["status"], { bg: string; fg: string }> = {
  pending:  { bg: "var(--ph-warning-tint)", fg: "var(--ph-warning)" },
  approved: { bg: "var(--ph-success-tint)", fg: "var(--ph-success)" },
  declined: { bg: "var(--ph-danger-tint)",  fg: "var(--ph-danger)"  },
};
function tname(id: string) { return AI_TEAMMATES.find((t) => t.id === id)?.name ?? id; }

export default function Approvals() {
  const [tab, setTab] = useState<AiApproval["status"] | "all">("pending");
  const filtered = useMemo(() => AI_APPROVALS.filter((a) => tab === "all" || a.status === tab), [tab]);

  return (
    <div className="space-y-6" data-testid="ai-approvals">
      <Card testId="ai-ap-filters">
        <TabBar<AiApproval["status"] | "all">
          testId="ai-ap-tabs"
          active={tab}
          onChange={setTab}
          tabs={[
            { key: "pending",   label: "Pending"   },
            { key: "approved",  label: "Approved"  },
            { key: "declined",  label: "Declined"  },
            { key: "all",       label: "All"       },
          ]}
        />
      </Card>

      <Card padded={false} testId="ai-ap-list">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}>
          <SectionHeader eyebrow="Approvals" title={`${filtered.length}`} />
        </div>
        <div className="p-2">
          {filtered.map((a) => {
            const m = STATUS_META[a.status];
            return (
              <div key={a.id} data-testid={`ai-ap-${a.id}`} className="p-3 rounded"
                style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}>
                <div className="flex items-baseline justify-between mb-2">
                  <div>
                    <div className="text-sm font-semibold" style={{ color: "var(--ph-ink-strong)" }}>{a.title}</div>
                    <div className="text-[11px]" style={{ color: "var(--ph-ink-muted)" }}>{tname(a.teammateId)} · {a.askedBy} · {a.askedRelative}</div>
                  </div>
                  <span className="px-1.5 py-0.5 text-[9px] font-semibold uppercase" style={{ letterSpacing: "0.14em", background: m.bg, color: m.fg, borderRadius: "var(--ph-radius-sm)" }}>{a.status}</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="flex-1">
                    <div className="text-[10px] uppercase tracking-[0.14em]" style={{ color: "var(--ph-ink-muted)" }}>Pending review</div>
                    <ConfidenceBar value={a.aiConfidence} />
                  </div>
                  <div className="text-sm tabular-nums" style={{ color: "var(--ph-ink-strong)" }}>EGP {a.amountEGP.toLocaleString()}</div>
                  {a.status === "pending" && <div className="flex gap-2"><Button variant="secondary" testId={`ai-ap-decline-${a.id}`}>Decline</Button><Button testId={`ai-ap-approve-${a.id}`}>Approve</Button></div>}
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
